import {AppointmentBookingBaseComponent} from "../appointment-booking-base.component";
import {Component, OnInit} from "@angular/core";


@Component({
    selector: 'as-appointment-booking-side',
    templateUrl: 'appointment-booking-side.component.html',
    standalone: false
})
export class AppointmentBookingSideComponent extends AppointmentBookingBaseComponent implements OnInit {


    ngOnInit() {
        super.ngOnInit();
    }

}
